import { useFocus } from '../../hooks/useFocus';

/**
 * Renders its children unless `k` is in the viewer's Focus set and their switch
 * is on Focus. The wrapper is `display: contents`, so layout is untouched, and it
 * carries `data-focus={k}` so clicks inside are counted against the Focus key.
 * Don't use it where a parent needs its direct children (MUI Tabs, ButtonGroup,
 * List) — check useFocus().isHidden(k) there instead.
 */
export default function FocusHide({ k, children }) {
  const { isHidden } = useFocus();
  if (isHidden(k)) return null;
  return <span data-focus={k} style={{ display: 'contents' }}>{children}</span>;
}
